import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { FloatingCTA } from "../components/FloatingCTA";
import { ScrollAnimation } from "../components/ScrollAnimation";

import Hero from "../components/sections/Hero";
import Intro from "../components/sections/Intro";
import About from "../components/sections/About";
import Approach from "../components/sections/Approach";
import Treatments from "../components/sections/Treatments";
import KAP from "../components/sections/KAP";
import Results from "../components/sections/Results";
import Testimonials from "../components/sections/Testimonials";
import Team from "../components/sections/Team";
import Gallery from "../components/sections/Gallery";
import Content from "../components/sections/Content";
import Contact from "../components/sections/Contact";

export default function Home() {
  return (
    <main className="w-full bg-[#faf9f7]">
      <Navigation />
      <Hero />
      <Intro />
      <ScrollAnimation><About /></ScrollAnimation>
      <ScrollAnimation delay={100}><Approach /></ScrollAnimation>
      <ScrollAnimation delay={100}><Treatments /></ScrollAnimation>
      <ScrollAnimation delay={100}><KAP /></ScrollAnimation>
      <ScrollAnimation delay={100}><Results /></ScrollAnimation>
      <ScrollAnimation delay={100}><Testimonials /></ScrollAnimation>
      <ScrollAnimation delay={100}><Team /></ScrollAnimation>
      <ScrollAnimation delay={100}><Gallery /></ScrollAnimation>
      <ScrollAnimation delay={100}><Content /></ScrollAnimation>
      <ScrollAnimation delay={100}><Contact /></ScrollAnimation>
      <Footer />
      <FloatingCTA />
    </main>
  );
}
